"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const SaveIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsx)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M5.037 2A3.037 3.037 0 002 5.037v13.925A3.037 3.037 0 005.037 22H18.962A3.037 3.037 0 0022 18.962V8.022c0-.279-.11-.545-.307-.742L16.72 2.307A1.048 1.048 0 0015.979 2H5.037zm0 2.096a.941.941 0 00-.94.941v13.925c0 .52.42.942.94.942h1.095v-7.215c0-.58.469-1.049 1.048-1.049h9.64c.58 0 1.049.47 1.049 1.049v7.215h1.093c.52 0 .942-.422.942-.942V8.456l-4.36-4.36H8.228V7.51h7.215a1.048 1.048 0 110 2.096H7.18c-.579 0-1.048-.47-1.048-1.048v-4.46H5.037zm3.191 15.808h7.544v-6.167H8.228v6.167z", fillRule: "evenodd" }) }));
exports.default = (0, IconContainer_1.default)(SaveIcon);
//# sourceMappingURL=index.js.map